export enum PathOp {
  DIFFERENCE,
  INTERSECT,
  UNION,
  XOR,
  REVERSE_DIFFERENCE
}
